function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevrijLogoCloud002(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "faang",
    transform: "matrix(1.43909,0,0,1.43909,140.228,-7.93177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "faang1",
    transform: "matrix(2.40945,0,0,2.40945,-144.374,-73.1393)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.8814,0,0,41.8814,121,73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.22,-0L0.22,-0.413L0.06,-0.413L0.06,-0.495L0.22,-0.495L0.22,-0.59C0.22,-0.633 0.234,-0.668 0.261,-0.693C0.288,-0.717 0.326,-0.73 0.374,-0.73L0.535,-0.73L0.535,-0.648L0.374,-0.648C0.353,-0.648 0.338,-0.643 0.327,-0.634C0.316,-0.624 0.31,-0.609 0.31,-0.59L0.31,-0.495L0.535,-0.495L0.535,-0.413L0.31,-0.413L0.31,-0L0.22,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.8814,0,0,41.8814,146.129,73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.252,0.01C0.194,0.01 0.148,-0.005 0.115,-0.035C0.082,-0.064 0.065,-0.104 0.065,-0.155C0.065,-0.206 0.082,-0.247 0.115,-0.276C0.148,-0.305 0.193,-0.32 0.25,-0.32L0.42,-0.32L0.42,-0.375C0.42,-0.409 0.41,-0.435 0.39,-0.454C0.369,-0.472 0.34,-0.481 0.303,-0.481C0.27,-0.481 0.243,-0.474 0.221,-0.461C0.199,-0.447 0.186,-0.428 0.183,-0.405L0.093,-0.405C0.099,-0.452 0.121,-0.49 0.16,-0.518C0.199,-0.546 0.247,-0.56 0.305,-0.56C0.368,-0.56 0.418,-0.544 0.455,-0.511C0.492,-0.478 0.51,-0.434 0.51,-0.378L0.51,-0L0.422,-0L0.422,-0.105L0.407,-0.105L0.422,-0.12C0.422,-0.08 0.407,-0.048 0.376,-0.025C0.345,-0.002 0.303,0.01 0.252,0.01ZM0.274,-0.061C0.317,-0.061 0.352,-0.072 0.379,-0.093C0.406,-0.114 0.42,-0.142 0.42,-0.175L0.42,-0.253L0.252,-0.253C0.222,-0.253 0.198,-0.245 0.181,-0.228C0.164,-0.211 0.155,-0.189 0.155,-0.16C0.155,-0.129 0.166,-0.105 0.187,-0.088C0.208,-0.07 0.237,-0.061 0.274,-0.061Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.8814,0,0,41.8814,171.258,73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.252,0.01C0.194,0.01 0.148,-0.005 0.115,-0.035C0.082,-0.064 0.065,-0.104 0.065,-0.155C0.065,-0.206 0.082,-0.247 0.115,-0.276C0.148,-0.305 0.193,-0.32 0.25,-0.32L0.42,-0.32L0.42,-0.375C0.42,-0.409 0.41,-0.435 0.39,-0.454C0.369,-0.472 0.34,-0.481 0.303,-0.481C0.27,-0.481 0.243,-0.474 0.221,-0.461C0.199,-0.447 0.186,-0.428 0.183,-0.405L0.093,-0.405C0.099,-0.452 0.121,-0.49 0.16,-0.518C0.199,-0.546 0.247,-0.56 0.305,-0.56C0.368,-0.56 0.418,-0.544 0.455,-0.511C0.492,-0.478 0.51,-0.434 0.51,-0.378L0.51,-0L0.422,-0L0.422,-0.105L0.407,-0.105L0.422,-0.12C0.422,-0.08 0.407,-0.048 0.376,-0.025C0.345,-0.002 0.303,0.01 0.252,0.01ZM0.274,-0.061C0.317,-0.061 0.352,-0.072 0.379,-0.093C0.406,-0.114 0.42,-0.142 0.42,-0.175L0.42,-0.253L0.252,-0.253C0.222,-0.253 0.198,-0.245 0.181,-0.228C0.164,-0.211 0.155,-0.189 0.155,-0.16C0.155,-0.129 0.166,-0.105 0.187,-0.088C0.208,-0.07 0.237,-0.061 0.274,-0.061Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.8814,0,0,41.8814,196.387,73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.092,-0L0.092,-0.55L0.182,-0.55L0.182,-0.445L0.201,-0.445L0.182,-0.424C0.182,-0.467 0.195,-0.501 0.221,-0.525C0.247,-0.548 0.283,-0.56 0.329,-0.56C0.384,-0.56 0.428,-0.543 0.461,-0.509C0.494,-0.475 0.51,-0.429 0.51,-0.37L0.51,-0L0.42,-0L0.42,-0.36C0.42,-0.399 0.409,-0.43 0.389,-0.451C0.368,-0.471 0.339,-0.482 0.303,-0.482C0.266,-0.482 0.236,-0.471 0.215,-0.448C0.193,-0.425 0.182,-0.393 0.182,-0.35L0.182,-0L0.092,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.8814,0,0,41.8814,221.515,73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.161,0.18L0.161,0.098L0.336,0.098C0.364,0.098 0.385,0.092 0.398,0.079C0.411,0.066 0.417,0.047 0.417,0.02L0.417,-0.05L0.419,-0.15L0.401,-0.15L0.418,-0.165C0.418,-0.125 0.405,-0.093 0.378,-0.07C0.351,-0.047 0.316,-0.035 0.271,-0.035C0.214,-0.035 0.17,-0.054 0.137,-0.091C0.104,-0.127 0.088,-0.177 0.088,-0.24L0.088,-0.356C0.088,-0.419 0.104,-0.468 0.137,-0.505C0.17,-0.542 0.214,-0.56 0.271,-0.56C0.316,-0.56 0.351,-0.548 0.378,-0.525C0.405,-0.502 0.418,-0.47 0.418,-0.43L0.401,-0.445L0.418,-0.445L0.418,-0.55L0.507,-0.55L0.507,0.02C0.507,0.069 0.492,0.108 0.462,0.137C0.431,0.166 0.389,0.18 0.335,0.18L0.161,0.18ZM0.298,-0.113C0.335,-0.113 0.365,-0.125 0.386,-0.148C0.407,-0.171 0.418,-0.204 0.418,-0.245L0.418,-0.35C0.418,-0.391 0.407,-0.424 0.386,-0.447C0.365,-0.47 0.335,-0.482 0.298,-0.482C0.26,-0.482 0.231,-0.471 0.21,-0.448C0.189,-0.425 0.178,-0.393 0.178,-0.35L0.178,-0.245C0.178,-0.202 0.189,-0.17 0.21,-0.147C0.231,-0.124 0.26,-0.113 0.298,-0.113Z",
    style: {
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.647536,-7.93003e-17,7.93003e-17,-0.647536,133.949,107.377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5,0L115,100L0,100L57.5,0Z",
    style: {
      fill: "rgb(220,37,37)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevrijLogoCloud002);
export default __webpack_public_path__ + "static/media/levrij-logo-cloud-002.803c3c4e4f9d79220191049d49c234f2.svg";
export { ForwardRef as ReactComponent };